import { render } from "./ProfileCryptosOwnedV1.1.vue?vue&type=template&id=5ecb84ca&scoped=true"
import script from "./ProfileCryptosOwnedV1.1.vue?vue&type=script&lang=js"
export * from "./ProfileCryptosOwnedV1.1.vue?vue&type=script&lang=js"

import "./ProfileCryptosOwnedV1.1.vue?vue&type=style&index=0&id=5ecb84ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecb84ca"]])

export default __exports__